import { useEffect, useRef, useCallback } from 'react'

export function usePopupHistoryClose(close) {
  const closeRef = useRef(close)
  closeRef.current = close
  const skipPopStateClose = useRef(false)

  useEffect(() => {
    if (!window.history.state?.imagePopup) {
      window.history.pushState({ imagePopup: true }, '')
    }

    const onPopState = () => {
      if (skipPopStateClose.current) {
        skipPopStateClose.current = false
        return
      }
      closeRef.current()
    }

    window.addEventListener('popstate', onPopState)
    return () => {
      window.removeEventListener('popstate', onPopState)
    }
  }, [])

  const handleClose = useCallback(() => {
    skipPopStateClose.current = true
    if (window.history.state?.imagePopup) {
      window.history.back()
    }
    closeRef.current()
  }, [])

  return handleClose
}
